import { Outlet } from "react-router-dom";
import { AppHeader } from "@/components/AppHeader";
import { AppFooter } from "@/components/AppFooter";
import { useAppSelector, useAppDispatch } from "@/store/hooks";
import { setProfile, setSessions } from "@/store/slices/authSlice";
import { useState } from "react";
import { UserProfile, Session } from "@/types/profile";

export default function PageLayout() {
    const { userName, userEmail, profile, sessions } = useAppSelector((state) => state.auth);
    const dispatch = useAppDispatch();
    const [profileImage, setProfileImage] = useState<string>("");

    return (
        <div className="min-h-screen bg-gradient-to-br from-background via-secondary/50 to-background flex flex-col">
            <AppHeader
                userName={userName}
                profile={profile}
                profileImage={profileImage}
            />
            <main className="flex-1 w-full">
                <Outlet context={{
                    profile,
                    setProfile: (p: UserProfile) => dispatch(setProfile(p)),
                    profileImage,
                    setProfileImage,
                    sessions,
                    setSessions: (s: Session[]) => dispatch(setSessions(s))
                }} />
                <AppFooter />
            </main>

        </div>
    );
}
